export const DELETE_CANCELLATION_REASON_MUTATION = gql`
    mutation deleteCancellationReason($id: Int!) {
        deleteCancellationReason(id: $id) {
            id
        }
    }
`;

export const CREATE_CANCELLATION_REASON_MUTATION = gql`
    mutation createCancellationReason($input: CreateCancellationReasonInput!) {
        createCancellationReason(input: $input) {
            description
        }
    }
`;
